import UiPageListSearch from "./UiPageListSearch";
import UiPageListSearch_DynamicSearchItem from "./UiPageListSearch_DynamicSearchItem";
import { EnumUiDynamicSearchItemType } from "./EnumUiDynamicSearchItemType";
import { EnumCompare } from "./EnumCompare";

/**
 * 计费重量分页列表-搜索条件分页列表-搜索条件
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListSearchCompanyCharge extends UiPageListSearch {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 公司Id
     */
    CompanyId?: string;
}

/**
 * 计费重量分页列表-搜索条件分页列表-搜索条件-表单校验
 */
export const DtoPageListSearchCompanyChargeRules = {
}

/**
 * 计费重量分页列表-搜索条件分页列表-搜索条件-动态搜索配置项
 */
export const DtoPageListSearchCompanyChargeDynamicSearchItems: UiPageListSearch_DynamicSearchItem[]  = [
]
